export function compileCleanupHandler(
  cleanupHandlerBody: string
): string {
  return `(outputs, params) => {
  ${cleanupHandlerBody}
}`;
}
